import { Heading } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/style-closet-react';
import { useLoaderData } from 'react-router-dom';

import { EditAddressForm, type EditAddressFormProps } from './EditAddressForm';

import { WithLayout } from '../RetailApp/components/WithLayout';
import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { locationAssign } from '../Shared/path-helpers';

export type EditAddressPageLoaderData = EditAddressFormProps;

const EditAddressWorkflowLayout: React.FC<EditAddressFormProps> = ({
  hasPendingIraWithdrawals = false,
  isMaybeCheckingUser = false,
}) => {
  return (
    <WorkflowLayout title="Personal Information" footer={null} closeHandler={() => locationAssign('/app/profile')}>
      <WorkflowLayout.Slot>
        <Heading variant="pageTitle">{isMaybeCheckingUser ? 'Update your addresses' : 'Update your address'}</Heading>
      </WorkflowLayout.Slot>
      <WorkflowLayout.Slot>
        <EditAddressForm
          hasPendingIraWithdrawals={hasPendingIraWithdrawals}
          isMaybeCheckingUser={isMaybeCheckingUser}
        />
      </WorkflowLayout.Slot>
    </WorkflowLayout>
  );
};

const EditAddressPage = () => {
  const { hasPendingIraWithdrawals, isMaybeCheckingUser } = useLoaderData<EditAddressPageLoaderData>();

  return (
    <WithLayout parts={{ sidebar: false, footer: true }}>
      <IdempotencyProviderWithFeatureRegistry featureName="settings">
        <EditAddressWorkflowLayout
          hasPendingIraWithdrawals={hasPendingIraWithdrawals}
          isMaybeCheckingUser={isMaybeCheckingUser}
        />
      </IdempotencyProviderWithFeatureRegistry>
    </WithLayout>
  );
};

export default EditAddressPage;
